module.exports = __webpack_public_path__ + "img/hangqing.f6c3e8e4.png";